const ManuallyAddedLegend = ({ className = '' }) => {
  return (
    <div className={`spo-a-manually-added-legend ${className}`}>
      <div></div>Handmatig toegevoegd
    </div>
  );
};

export default ManuallyAddedLegend;
